import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IMyOptions } from 'ng-uikit-pro-standard';
// tables
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { EstimateService } from 'src/app/services/estimate.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomDataTable, FilterBody } from 'src/app/models/custom-data-table';
import { environment } from 'src/environments/environment';
import { GeneralService } from 'src/app/services/general.service';
import { StepChangeEvent } from 'ng-uikit-pro-standard/lib/pro/stepper/stepper.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { TaskService } from 'src/app/services/task.service';
import { DxDataGridComponent, DxSelectBoxComponent, DxTreeListComponent } from 'devextreme-angular';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { TreeviewAreaSystemComponent } from 'src/app/shared/treeview-area-system/treeview-area-system.component';
import { MapInformationService } from 'src/app/services/map-information.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { DatePipe } from '@angular/common';
declare var $: any;
import { TranslateService } from '@ngx-translate/core';
import { ProjectService } from 'src/app/services/project.service';
// import introjs
import * as introJs from 'intro.js/intro.js';
import config from 'devextreme/core/config';
const EXCEL_EXTENSION = '.xlsx';
import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

config({
  floatingActionButtonConfig: {
    icon: 'icon ion-md-share',
    position: {
      my: 'right bottom',
      at: 'right bottom',
      of: '#app-container',
      offset: '-45% 0.15%'
    }
  }
});
@Component({
  selector: 'app-pay-credit',
  templateUrl: './pay-credit.html',
  styleUrls: ['./pay-credit.component.scss']
})
export class PayCreditComponent implements OnInit {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild('row', { static: true }) row: ElementRef;
  @ViewChild('gridEngEstimate', { static: false }) gridEngEstimate: DxDataGridComponent;
  @ViewChild("searchProject", { static: false }) searchProject: DxSelectBoxComponent;



  @Input() currentBalance: any;
  @Input() remainingBalance: any;
  @Input() serviceCost: any;
  @Input() titleCredit: any;
  @Input() showAIMessage: any;
  @Input() code: any; 
  @Input() textSaveAccount: any; 

  @Output() returnInfo = new EventEmitter<any>();
  @Output() returnClosePopupPay = new EventEmitter<any>();


  // introjs hint
  introJS = introJs();
  isHelpVisible: boolean = false;
  viewTypeCard: any;
  elements: any = [];

  headElements = [{ head: 'Estimate Id', id: 'EstimateId', class: 'text-right' }, { head: 'Project Name', id: 'ProjectName', class: 'text-left' }, { head: 'Category', id: 'Category', class: 'text-left' }, { head: 'Vertical Market', id: 'VerticalMarket', class: 'text-left' }, { head: 'Status', id: 'Status', class: 'text-left' }, { head: 'Date', id: 'Date', class: 'text-right' }];

  searchText: string = '';
  previous: string;

  maxVisibleItems: number = 8;

  EstimateID2: 'AAA';
  filterCategory: any;
  optionsSelect: Array<any>;
  optionsSelect2: Array<any>;
  optionsSelect3: Array<any>;
  optionsVMarket: Array<any>;
  optionsCustomer: Array<any>;
  optionsFirm: Array<any>;
  optionsCategory: Array<any> = [];
  taxes: Array<any>;
  typeSupport: Array<any>;
  file: File;

  dateFormat = '';
  title = 'app';
  EstimateID = '';
  estimates: any = [];
  totalRecords = 0;
  filterCategorySelect: any = [];
  modelFilterCategory: any = [];
  filterStatusSelect: any = [];
  modelFilterStatus: any = [];
  filterVerticalMarketSelect: any = [];
  modelFilterVerticalMarket: any = [];
  estimateFilters = {
    pageindex: 1,
    pagesize: 20,
    estimateid: 0,
    projectname: '',
    categoryids: '',
    verticalmarketids: '',
    orderid: -1,
    statusids: '',
    collapseFilters: true
  };
  loading = false;
  customData: CustomDataTable = new CustomDataTable();
  activePage: number = 0;
  lastSearchZero: boolean = false;

  // popupNewEstimate = false;
  popupDeleteEstimate = false;

  showtree = true;
  @ViewChild('treeRecomended', { static: false }) treeRecomended: DxTreeListComponent;
  @ViewChild("treeviewAreaSystem", { static: false }) treeviewAreaSystem: TreeviewAreaSystemComponent;
  estimateDataSource = [];
  estimateSelected: any = {};
  cancelButtonDeleteEstimate: any;
  saveButtonDeleteEstimate: any;

  cancelButtonDuplicateEstimate: any;
  saveButtonDuplicateEstimate: any;
  popupDuplicateEstimate = false;

  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;
  DateFilter: any = new Date();
  millisecondsInDay = 24 * 60 * 60 * 1000;
  popupNewEstimate = false;
  filterValue: any[];

  loadinfoOnce: boolean = true
  index: any = 1
  formatCurrency: any

  actualState: any = 0;
  gridId: any = "GridNewEstimate3";
  options = {
    translations: {
      textElements: {
        paragraph: 'Paragraf',
        heading: 'Nagłówek',
        preformatted: 'Pre-formatowany',
      },
      textStyle: {
        bold: 'Pogrubione',
        italic: 'Italiczne',
        strikethrough: 'Przekreślone',
        underline: 'Podkreślone',
        color: 'Kolor',
      },
      textAlign: {
        justifyLeft: 'Lewy',
        justifyCenter: 'Środek',
        justifyRight: 'Prawy',
        justifyFull: 'Justowanie',
      },
      imageAndLink: {
        createLink: 'Wstaw Link',
        insertImage: 'Wstaw zdjęcie',
        linkURLPlaceholder: 'Podaj adres',
        imageURLPlaceholder: 'Podaj adres obrazka',
      },
      lists: {
        insertUnorderedList: 'Lista wypunktowana',
        insertOrderedList: 'Lista numerowana',
      },
      showHTML: 'Pokaż HTML',
    }
  }
  addCustomerButton: { icon: string; type: string; hint?: string; onClick: () => void; elementAttr?: { id: string; }; };

  popupCreateSalesProject: boolean = false
  groupedAccordionData: { title: any; subgroups: unknown[]; }[];
  popupInsufficientCredits: boolean;

  planid: any = 0
  creditAvailable: any;
  
  

  constructor(
    private MapInformationService: MapInformationService,
    private fileSaverService: FileSaverService,
    private EstimateService: EstimateService,
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    private activatedRoute: ActivatedRoute,
    private ProjectService: ProjectService,
    private generalService: GeneralService,
    private appsettings: AppConfigService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private taskService: TaskService,
    private toast: ToastService,
    private pipeDate: DatePipe,
    private router: Router,
  ) {
    const page = activatedRoute.snapshot.paramMap.get('page');
    this.estimateFilters.pageindex = page ? parseInt(page) : 1;
    this.activePage = this.estimateFilters.pageindex;
    this.dateFormat = this.appsettings.dateFormat;

    // this.formatCurrency = {style: 'currency', currency: this.appsettings.moneyFormat}
    this.formatCurrency = { style: 'currency', currency: this.appsettings.moneyFormat }

    let moneyTableFormat = this.appsettings.moneyFormat;
    if (this.appsettings.moneyFormat == '$') { moneyTableFormat = 'USD' }

    this.formatCurrency = { style: 'currency', currency: moneyTableFormat }

    this.addCustomerButton = {
      icon: "plus",
      hint: "Add Project",
      type: "button",
      elementAttr: {
        id: "hintCreateNewProject",
      },
      onClick: () => {
        this.popupCreateSalesProject = true;
        this.introJS.nextStep();
      },
    };


  }
  ngOnDestroy() {
    localStorage.setItem('EstimateID', this.EstimateID);
  }

  ngOnInit() {

    this.validateFormCredit()


  }

  duplicateEstimateNew() {
    this.estimateService.Insert_EstimateDuplicate(this.estimateSelected.ESTIMATEID).subscribe(result => {
      this.getEstimateDateSource();
      this.toast.success(this.translate.instant('ModuleEng.msgEstDuplSucc'));
      this.popupDuplicateEstimate = false;
    })
  }
  goEditEstimate(item) {
    localStorage.setItem("ModuleFrom", "Estimate")

    // this.router.navigateByUrl(`/Estimates/editEstimate?numESTIMATEID=${item.ESTIMATEID}&numProjectID=${item.ProjectID}&statusID=${item.STATUSID}&strPROJECT_NAME=${item.PROJECT_NAME}`)

    this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: item.ESTIMATEID, numProjectID: item.ProjectID, statusID: item.STATUSID, strPROJECT_NAME: item.PROJECT_NAME } });
  }

  GetFilters(data) {
    if (data.component.option("filterValue")) {
      // console.log(data.component.option("filterValue"))
      localStorage.setItem('filterGridEstimates', JSON.stringify(data.component.option("filterValue")));
    } else {
      localStorage.removeItem('filterGridEstimates');
      this.filterValue = []
    }
  }

  saveOrDuplicate: any = ""

  getAction(item, duplicate = true) {



    if (item.STATUSID == 3 && !duplicate) {
      this.toast.warning(this.translate.instant('ModuleEng.msgEstSold'));
      return;
    }


    if (duplicate) {

      if (this.planid == "11") {
        this.MapInformationService.SaveInfoSites({
          method: "GetClientCubeShopCredit",
        }).subscribe(resp => {
          if (resp[0].credit) {

            if (resp[0].credit > 50) {


              this.currentBalance = resp[0].credit
              this.remainingBalance = this.currentBalance - this.estimateCost

              this.showPopupPlane = true
              this.saveOrDuplicate = "Duplicate"
            } else {
              this.popupInsufficientCredits = true
            }
          }
        })



      } else {
        this.popupDuplicateEstimate = true
      }

    } else {
      this.popupDeleteEstimate = true;
    }

    this.estimateSelected = item;
    // this.estimateService.DeleteEstimate(item.ESTIMATEID).subscribe(result => {
    //   console.log(result);
    //   this.getEstimateDateSource();
    // })
  }

  convertdate(str) {
    var date = new Date(str)
    var day: any = date.getDate()
    var month: any = date.getMonth() + 1;
    return [date.getFullYear(), month, day].join("-") + " 00:00:00";
  }

  onStepChange(event: StepChangeEvent) {

    if (event.activeStepIndex == 1 && event.previousStep.isDone == true) {
      // this.userService.createUser(event.previousStep.stepForm.controls.email.value, event.previousStep.stepForm.controls.password.value).subscribe(result => {
      //   if (result["error"] == -1){
      //     this.toast.error('Error User exists.');
      //     this.stepper.previous();
      //   }
      //   else{
      //     this.toast.success(this.translate.instant('msgUseCre'));
      //   }
      //   this.secondFormGroup.get('userEmail').setValue(event.previousStep.stepForm.controls.email.value);
      // })
    }

    else if (event.activeStepIndex == 2 && event.previousStep.isDone == true) {
      var mythis = this;
      // this.lmNewtUser.hide();
      // this.userService.createClientUser(event.previousStep.stepForm.controls.userEmail.value, event.previousStep.stepForm.controls.lastname.value, event.previousStep.stepForm.controls.firstname.value, event.previousStep.stepForm.controls.employee.value, 0, 0, 1).subscribe(result => {
      //   var lUserID = result[0].ResultID;
      //   mythis.userService.getUsers().subscribe(result => {
      //     mythis.users = result;
      //     mythis.userID = lUserID;
      //     this.viewTypeCard = 1;
      //   })
      //   // this.userID = result[0].ResultID;
      //   // this.router.navigateByUrl('/groups/' + result[0].ResultID * -1)
      // })
    }

  }

  getInitials(str) {
    return this.generalService.getInitials(str);
  }

  clearFilter() {
    this.estimateFilters = {
      pageindex: 1,
      pagesize: 20,
      estimateid: 0,
      projectname: '',
      categoryids: '',
      verticalmarketids: '',
      orderid: -1,
      statusids: '',
      collapseFilters: true
    };
    this.modelFilterCategory = [];
    this.modelFilterStatus = [];
    this.modelFilterVerticalMarket = [];
    this.estimates = [];
    this.lastSearchZero = false;
    this.onPageChange(1);
  }

  onPageChange(activePageNumber: number) {
    this.activePage = activePageNumber;
    this.estimateFilters.pageindex = activePageNumber;
    // this.router.navigateByUrl('/Estimates/' + this.activePage);
    this.GetEstimates();
  }

  onSort(position) {
    this.estimateFilters.orderid = position;
    this.onPageChange(1);
  }

  // Create filter object looking for value by array position
  search(filterBody: Array<FilterBody>) {
    this.estimateFilters.estimateid = filterBody[0].filterValue ? filterBody[0].filterValue : 0;
    this.estimateFilters.projectname = filterBody[1].filterValue ? filterBody[1].filterValue : '';
    this.estimateFilters.categoryids = filterBody[2].filterValue ? `${filterBody[2].filterValue.join(',')}` : '';
    this.estimateFilters.statusids = filterBody[3].filterValue ? `${filterBody[3].filterValue.join(',')}` : '';
    this.estimateFilters.verticalmarketids = filterBody[4].filterValue ? `${filterBody[4].filterValue.join(',')}` : '';
    this.onPageChange(1);
  }

  storageToFilters() {
    this.customData.filterBody[0].filterValue = this.estimateFilters.estimateid;

    this.customData.filterBody[1].filterValue = this.estimateFilters.projectname;

    // tslint:disable-next-line: max-line-length
    this.customData.filterBody[2].filterValue = this.estimateFilters.categoryids;

    // tslint:disable-next-line: max-line-length
    this.customData.filterBody[3].filterValue = this.estimateFilters.statusids;

    // tslint:disable-next-line: max-line-length
    this.customData.filterBody[4].filterValue = this.estimateFilters.verticalmarketids;
  }

  GetEstimates(isFilter = false) {
    if (this.loading == true) { return 0; }
    this.loading = true;
    if (isFilter) {
      this.estimateFilters.statusids = this.modelFilterStatus ? this.modelFilterStatus.join(',') : '';
      this.estimateFilters.verticalmarketids = this.modelFilterVerticalMarket ? this.modelFilterVerticalMarket.join(',') : '';
      this.estimateFilters.categoryids = this.modelFilterCategory ? this.modelFilterCategory.join(',') : '';
      this.estimateFilters.pageindex = 1;
      this.lastSearchZero = false;
    }

    var mythis = this;


    localStorage.setItem('estimateFilters', JSON.stringify(this.estimateFilters));
    this.EstimateService.GetEstimates(this.estimateFilters).subscribe(result => {

      // this.estimates = result;
      // if (this.estimates.length > 0) {
      //   this.totalRecords = this.estimates[0].recordsCount;
      //   localStorage.setItem('estimateData', JSON.stringify(this.estimates));
      // }

      this.loading = false;

      mythis.estimateFilters.pageindex++;

      if (result.length > 0) {

        if (isFilter) {
          this.estimates = result;
        } else {

          var tempCopy = JSON.parse(JSON.stringify(this.estimates));

          result.forEach(element => {
            tempCopy.push(element);
          });

          this.estimates = tempCopy;

          // this.salesProject = this.salesProject.concat(result);
          // result.forEach(element => {
          //   this.salesProject.push(element);
          // });
        }

        // if (isFilter) {
        //   this.estimates = result;
        // } else {
        //   result.forEach(element => {
        //     this.estimates.push(element);
        //   });
        // }


      }
      else {
        mythis.lastSearchZero = true;
      }

      if (isFilter && result.length == 0) {
        this.estimates = [];
      }

      localStorage.setItem('estimateData', JSON.stringify(this.estimates));

    });
  }

  GetEstimatesFilter() {
    this.EstimateService.GetEstimatesFilter().subscribe(result => {
      this.filterCategorySelect = result.salesCategory.map((val) => {
        return { // Return the new object structure
          label: val.projectsLsCategory,
          value: val.id
        };
      });

      this.filterVerticalMarketSelect = result.verticalMarket ? result.verticalMarket.map((val) => {
        return {
          label: val.vertMarketDescription,
          value: val.id
        };
      }) : [];

      this.filterStatusSelect = result.bidStatus.map((val) => {
        return {
          label: val.bidStatusDescription,
          value: val.id
        };
      });
      // this.categories = [...this.categories, { value: result.identity, label: this.newDashboard.name }];
    });
  }

  public myDatePickerOptions: IMyOptions = {
    // Your options
  }

  addNewRow() {
    this.mdbTable.addRow({
      id: this.elements.length.toString(),
      first: 'Wpis ' + this.elements.length,
      last: 'Last ' + this.elements.length,
      handle: 'Handle ' + this.elements.length
    });
    this.emitDataSourceChange();
  }

  addNewRowAfter() {
    this.mdbTable.addRowAfter(1, { id: '2', first: 'Nowy', last: 'Row', handle: 'Kopytkowy' });
    this.mdbTable.getDataSource().forEach((el: any, index: any) => {
      el.id = (index + 1).toString();
    });
    this.emitDataSourceChange();
  }

  removeLastRow() {
    this.mdbTable.removeLastRow();
    this.emitDataSourceChange();
    this.mdbTable.rowRemoved().subscribe((data: any) => {
      console.log(data);
    });
  }

  removeRow() {
    this.mdbTable.removeRow(1);
    this.mdbTable.getDataSource().forEach((el: any, index: any) => {
      el.id = (index + 1).toString();
    });
    this.emitDataSourceChange();
    this.mdbTable.rowRemoved().subscribe((data: any) => {
      console.log(data);
    });
  }

  emitDataSourceChange() {
    this.mdbTable.dataSourceChange().subscribe((data: any) => {
      console.log(data);
    });
  }
  // file
  onFileAdd(file: File) {
    this.file = file;
  }

  onFileRemove() {
    this.file = null;
  }

  customScroll() {
    var mythis = this;

    $('#myScrollEstimates').on('scroll', function () {
      if (($(this).scrollTop() + $(this).innerHeight() + 100) >= $(this)[0].scrollHeight) {
        if (mythis.lastSearchZero == false) {
          mythis.GetEstimates();
        }
      }
    });
  }


  onContentReady(e) {
    let filter = e.component.getCombinedFilter();
    // console.log(filter.filterValue);
    // if(filter !== undefined && this.filterActive ==false){
    //   this.filterActive = true;
    // }

    let mythis = this
    e.component.getScrollable().on("scroll", function (e) {
      if (e.reachedBottom == true && mythis.loadinfoOnce == true) {
        mythis.index = mythis.index + 1;
        mythis.loadinfoOnce = false
        mythis.getEstimateDateSource();
      }
    })
  }

  getEstimateDateSource() {
    let info = {
      method: "Get_EstimatesAllPaged",
      pageindex: this.index,
      pagesize: 30
    }
    // this.MapInformationService.SaveInfoSites(info).subscribe(result => {
    this.estimateService.Get_EstimatesAll().subscribe(result => {
      // console.log('all estimates', result);
      this.estimateDataSource = result.map(x => {
        x.Not_ForContruction == true ? x.Not_ForContructionYesOrNo = "Yes" : x.Not_ForContructionYesOrNo = "No"
        x.Is_Library == true ? x.Is_LibraryYesOrNo = "Yes" : x.Is_LibraryYesOrNo = "No"
        x.Show_Com == true ? x.Show_ComYesOrNo = "Yes" : x.Show_ComYesOrNo = "No"


        // const fecha = this.pipeDate.transform(x.ESTIMATEDATE, 'MM/dd/yyyy');
        // x.ESTIMATEDATE = fecha

        let year = this.pipeDate.transform(x.ESTIMATEDATE, 'yyyy');
        x.ESTIMATEDATE = parseInt(year) < 1990 ? null : this.pipeDate.transform(x.ESTIMATEDATE, 'MM/dd/yyyy');

        return x
      })
      // this.estimateDataSource = [...this.estimateDataSource,...result];
      console.log(this.estimateDataSource)
      this.loadinfoOnce = true
    })

  }

  ModifyConstrution(event, data) {
    console.log(event)
    console.log(data)

    const info = {
      method: "Update_EstimatesNFC",
      NotForConstruction: event.value == true ? 1 : 0,
      EstimateID: data.data.ESTIMATEID
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModuleEng.msgNConUpSucc'));
        this.getEstimateDateSource()
      })
  }

  ModifyIsLibrary(event, data) {
    console.log(event)
    console.log(data)

    const info = {
      method: "Update_EstimatesIsLibrary",
      islibrary: event.value == true ? 1 : 0,
      EstimateID: data.data.ESTIMATEID
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModuleEng.msgNConUpSucc'));
        this.getEstimateDateSource()
      })
  }

  ModifyIsShow_Com(event, data) {
    console.log(event)
    console.log(data)

    const info = {
      method: "Update_EstimatesIsComm",
      iscomm: event.value == true ? 1 : 0,
      EstimateID: data.data.ESTIMATEID
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModuleEng.msgNConUpSucc'));
        this.getEstimateDateSource()
      })
  }



  // refresh and column chooser
  customizeColumns(columns) {
    let result = localStorage.getItem('GridEstimateNew1');

    if (result) {
      let data = JSON.parse(result);

      let finalColumns = columns.map((col, i) => {
        if (data[i] != undefined) {
          // data[i].name ? col.caption = data[i].name : '';
          data[i].dataField ? col.dataField = data[i].dataField : '';
          data[i].dataType ? col.dataType = data[i].dataType : '';
          col.visible = data[i].visible;
          col.visibleIndex = data[i].visibleIndex;
          data[i].width ? col.width = data[i].width : '';
          return col;
        }
      });
      return finalColumns
    }
  }

  saveState1 = (state) => {
    // console.log('Save ', state);
    // console.log('Actual State ', this.actualState)
    if (this.actualState == 0) {
      // console.log('States es 0')
      this.ProjectService.InsertUpdateGridConfiguration(0, this.gridId, state.filterValue, JSON.stringify(state.columns)).subscribe(result => {
        console.log('Guardado ', result);
        return state;
      })
    } else if (this.actualState.ID) {
      this.ProjectService.InsertUpdateGridConfiguration(this.actualState.ID, this.gridId, state.filterValue, JSON.stringify(state.columns)).subscribe(result => {
        console.log('Guardado Editando', result);
        return state;
      })
    }
  }

  onToolbarPreparing(e, buttonName) {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        template: 'buttonsLeft'
      }, {

      location: 'after',
      template: 'buttonsRight'
    },
      {
        location: "after",
        widget: "dxButton",
        options: {
          text: "",
          elementAttr: {
            id: "hintExportEst"
          },
          hint: 'Export all data',
          icon: "assets/export-to-excel.png",
          onClick: () => {
            // this.gridEngEstimate.instance.
            this.exportAsExcelFile(this.estimateDataSource, 'Estimates');
          },
        },
      },
    );
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    this.fileSaverService.save(data, fileName + EXCEL_EXTENSION);
  }






  goToTutorial(id) {
    // let id = "ibtVDO1"
    // this.router.navigateByUrl()

    let url = window.location.href.split("#");
    let finalUrl = url[0] + `#/videoTutorial?numVideo=${id}`;
    console.log(finalUrl)
    window.open(finalUrl, "_blank");

  }

  itemsEstimate = [
    {
      id: 1,
      name: "By Selecting Systems from Library",
      icon: "fas fa-project-diagram",
    },
    {
      id: 2,
      name: "Quick Entry",
      icon: "fas fa-project-diagram",
    }
  ];

  popupNewEstimateQuick: boolean = false
  firstFormGroup: FormGroup;
  projectslist: CustomStore;
  projectName: any = ""

  onItemsClick(e = null) {
    let idSelected = e.itemData.id
    switch (idSelected) {
      case 1:
        // this.OpenModalImportExcel()
        this.popupNewEstimate = true
        break;
      case 2:
        this.newEstimateFormat()
        break;
    }
  }

  IsAssistant: boolean = false



  initForm() {
    this.firstFormGroup = new FormGroup({
      projectid: new FormControl('', [Validators.required]),
      projectname: new FormControl('', [Validators.required]),
      projectnameTemp: new FormControl('', [Validators.required]),
    });
  }

  initformAndSelect() {

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        // return mythis.taskService.GetProjectByName(loadOptions.searchValue)
        return mythis.ProjectService.Get_All_SalesProjectsByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            // console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  updateProjectInfo(obj) {
    console.log(obj);
    if (obj.selectedItem) {
      this.firstFormGroup.get('projectname').setValue(obj.selectedItem.Project_Name);
      this.firstFormGroup.get('projectid').setValue(obj.selectedItem.ID);
      this.firstFormGroup.get('projectnameTemp').setValue(obj.selectedItem.Project_Name);
    } else {
      this.firstFormGroup.get('projectname').setValue(null);
      this.firstFormGroup.get('projectid').setValue(null);
    }
  }

  createProject() {
    // console.log(this.projectName)
    if (this.projectName != undefined) {
      let info =
      {
        "bidreqdate": "",
        "biddate": "",
        "projectid": 0,
        "projectnum": null,
        "name": this.projectName,
        "siteid": 0,
        "salescategoryid": 1,
        "bidstatus": 1,
        "closedate": "",
        "amount": 0,
        "profit": 0,
        "profitpercent": 0,
        "consultingid": 0,
        "salesemp": 0,
        "custreqpriceid": 0,
        "custawardprojectid": 0,
        "projectverticalid": 1,
        "awardedto": 0,
        "productspecified": 0,
        "partestimaterequestbyid": 0,
        "prevailingwagecode": 0,
        "notbidreason": 0,
        "salescomment": "",
        "salesnotes": "",
        "address": "",
        "addressline2": "",
        "city": "",
        "state": "",
        "country": "",
        "zip": "",
        "lat": 0,
        "lon": 0,
        "prevailingwage": 0,
        "method": "InsertUpdate_SalesProjectsCE"
      }

      this.MapInformationService.SaveInfoSites(info)
        .subscribe(resp => {


          this.firstFormGroup.get('projectid').setValue(resp[0].ReturnID);
          this.firstFormGroup.get('projectname').setValue(this.projectName);
          this.firstFormGroup.get('projectnameTemp').setValue(this.projectName);
          this.searchProject.placeholder = resp[0].ReturnID + " " + this.projectName

          this.toast.success("Project created successfully")
          this.projectName = ''
          this.popupCreateSalesProject = false
          this.initformAndSelect()
          if (this.IsAssistant) {
            this.introJS.nextStep();
          }
        })
    } else {
      this.toast.warning("You must write a name")
    }
  }

  showPopupPlane: boolean = false

  // Variables para el popup del plan
  estimateCost: number = 50.00


  createEstimate() {
    let dataFinal = this.firstFormGroup.value

    if (dataFinal.projectid == null || dataFinal.projectid == undefined || dataFinal.projectid == 0 || dataFinal.projectid == "") {
      this.toast.warning("You must select a project")
      return
    }


    if (this.planid == "11") {

      this.showPopupPlane = true
      this.saveOrDuplicate = "Save"

    } else {
      let dataFinal = this.firstFormGroup.value
      const currentuserid = localStorage.getItem("customerid");
      let project = this.firstFormGroup.value;


      if (dataFinal.projectid == null || dataFinal.projectid == undefined || dataFinal.projectid == 0 || dataFinal.projectid == "") {
        this.toast.warning("You must select a project")
        return
      }

      this.estimateService.InsertEstimateWithTax(
        dataFinal.projectid,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        currentuserid,
        undefined,
        undefined,
      ).subscribe(result => {
        if (result[0]) {
          let estimateid = result[0].ID;
          this.estimateService
            .Insert_EstimateAreaCE(estimateid, 'Area 1', 0, 1, true)
            .subscribe((area) => {
              this.introJS.exit();
              if (area[0]) {


                localStorage.setItem("ModuleFrom", "Estimate")

                localStorage.setItem("showModalInEdit", "Yes")

                this.toast.success(this.translate.instant('msgEstCreSucc'));
                this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: estimateid, numProjectID: project.projectid, strPROJECT_NAME: project.projectname } });
              }
            });
        }
      })

    }

  }

  blockSaveEstimatePay: boolean = false


  SaveEstimatePayPreview() {
    const data = {
      showModalSuccess:false
    }
    this.showPopupPlane = false
    this.returnInfo.emit(data)
  }

  
  SaveEstimatePay() {


    this.MapInformationService.SaveInfoSites(
      {
        "method": "AddClientCubeShopTransaction",
        "clientid": localStorage.getItem("customerid"),
        "amount": this.serviceCost * -1,
        "details": this.textSaveAccount
      }
    ).subscribe(respContract => {
      console.log("aqui")
      
      this.showPopupPlane = false
      const data = {
        showModalSuccess:true,
        dontapplylogic:true
      }
      this.returnInfo.emit(data)

    }, error => {
    })


  }

  closeAll(){
    this.returnInfo.emit()
  }

  showPopupShop: boolean = false
  ShowModalShop() {
    this.showPopupShop = true
    this.getEstimateSelect()
  }


  estimateDataSourceSelect: CustomStore;

  getEstimateSelect() {
    let mythis = this
    this.estimateDataSourceSelect = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  goToShop: boolean = false

  goToNewEstimateShop() {
    this.goToShop = true
    this.initformAndSelect()
    this.initForm()

    this.popupNewEstimateQuick = true
  }


  estimateSelectedShop: any

  updateEstimateSelected(obj) {
    console.log(obj);
    if (obj.selectedItem) {
      console.log(obj.selectedItem)
      this.estimateSelectedShop = obj.selectedItem
    }
  }

  goToCubeShop() {

    localStorage.removeItem("estimateIDSelected")
    localStorage.removeItem("estimatenamestrSelected")
    localStorage.removeItem("projectIDSelected")
    localStorage.removeItem('CreateInAEstimate');
    localStorage.removeItem("fromCommissioning")

    this.showPopupShop = false

    this.router.navigateByUrl(`/applications`)

  }


  // ======================== Guide Tour ========================

  GetAllHintGroupsByModule() {
    this.MapInformationService.SaveInfoSites({ method: "GetAllHintGroupsByModule" })
      .subscribe(resp => {
        console.log("resptesttttttttttttt213121", resp)

        const groupMap = new Map<string, any>();

        for (const item of resp) {

          if (item.COMPONENT == "EST-GRID") {
            const groupName = item.GROUPNAME;
            const subGroupName = item.SUBGROUPNAME;
            const COMPONENT = item.COMPONENT;


            if (!groupMap.has(groupName)) {
              groupMap.set(groupName, {
                title: groupName,
                component: COMPONENT,
                subgroups: new Map(),
                navigationName: item.NAVIGATIONNAME
              });
            }

            const group = groupMap.get(groupName);

            if (!group.subgroups.has(subGroupName)) {
              group.subgroups.set(subGroupName, {
                name: subGroupName,
                items: [],
                component: COMPONENT,
                navigationName: item.NAVIGATIONNAME
              });
            }

            group.subgroups.get(subGroupName).items.push({
              id: item.HINTID,
              element: item.ELEMENT,
              intro: item.INTRO,
              component: COMPONENT,
              navigationName: item.NAVIGATIONNAME
            });
          }

          // Convertir a array legible
          this.groupedAccordionData = Array.from(groupMap.values()).map(g => ({
            title: g.title,
            subgroups: Array.from(g.subgroups.values())
          }));

        }
      });
  }




  // Guide Tour
  NameComponent: any = "ENG-ENGPROJ-MODNEWEST"
  // NameComponent:any="CubeBoxComponent_IOs"
  helpSteps: any;

  // GuideTour

  GetHelpSteps() {
    this.isHelpVisible = true

  }

  componentSelected: string = ""

  GuideTour(subgroupItems: any[], component: string, deleteStep: boolean = false, position: number = 0) {

    this.IsAssistant = true

    this.MapInformationService.GetHelpSteps(component).subscribe(resp => {
      console.log("revision", resp)

      // Ordenar la respuesta por el campo ORDER
      resp.sort((a, b) => (a.order || 0) - (b.order || 0));

      let dataSteps = []
      resp.forEach((item) => {
        if (item.NAVIGATIONNAME != undefined) {
          item.intro = item.NAVIGATIONNAME
          dataSteps.push(item)
        }
      })


      console.log("this.planid", this.planid)


      if (this.planid == "11") {

        this.MapInformationService.SaveInfoSites({
          method: "GetClientCubeShopCredit",
        }).subscribe(respCredit => {
          console.log("respCredit", respCredit)
          if (respCredit[0].credit) {


            if (respCredit[0].credit >= 50) {
              dataSteps = dataSteps.filter((item, index) => {
                return item.DESCRIPTION != "Optional-dont-credit"
              })
            }




            if (50 > respCredit[0].credit) {
              dataSteps = dataSteps.filter((item, index) => {
                return index == 0 || item.DESCRIPTION == "Optional-dont-credit"
              })
              console.log("dataSteps", dataSteps)
            }
          }


          switch (component) {
            case "ENG-ENGPROJ-MODNEWEST": // New System
              break;
            case "ENG-ENGPROJ-MODNEWEXCEL":
              break;
            case "ENG-ENGPROJ-IMPORT-MASTER-LIBRARY":

              break;
            case "ENG-NEW-COMPONENT":
              break;
            default:
              break;
          }

          if (deleteStep) {
            dataSteps.splice(position, 1);
          }

          console.log("dataSteps", dataSteps)

          this.creditAvailable = respCredit[0].credit

          dataSteps.map((item) => {
            item.position = 'right'
          })

          this.activeStepper(dataSteps, component, true, false)
        })


      } else {
        this.componentSelected = component
        switch (component) {
          case "ENG-ENGPROJ-MODNEWEST": // New System
            break;
          case "ENG-ENGPROJ-MODNEWEXCEL":
            break;
          case "ENG-ENGPROJ-IMPORT-MASTER-LIBRARY":

            break;
          case "ENG-NEW-COMPONENT":
            break;
          default:
            break;
        }

        if (deleteStep) {
          dataSteps.splice(position, 1);
        }

        console.log("dataSteps", dataSteps)

        dataSteps.map((item) => {
          item.position = 'right'
        })

        this.activeStepper(dataSteps, component, true, false)
      }
    })
  }

  closeStepper(component) {
    console.log("closeStepper")
    this.introJS.exit();
  }

  activeStepper(dataSteps, component, validateStep: boolean = false, deactivate: boolean = false) {
    console.log("activeStepper", dataSteps)

    console.log("component", component)


    let mythis = this

    if (deactivate) {
      this.introJS.exit();
    }
    this.introJS.setOptions({
      steps: dataSteps,
      hidePrev: true,
      hideNext: false,
      disableInteraction: false,
      exitOnOverlayClick: false,
      exitOnEsc: false,
      keyboardNavigation: true,
      showProgress: true,
      showBullets: true,
      overlayOpacity: 0.8,
      showButtons: true,
      showCloseButton: true
    }).onbeforechange((targetElement) => {
      // Obtener el ID del elemento actual (de donde vengo)
      const currentStepIndex = this.introJS._currentStep - 1; // IntroJS usa índice base 1, pero el array es base 0
      const currentElement = dataSteps[currentStepIndex];
      const currentElementId = currentElement ? currentElement.element : null;


      console.log("this.planid", this.planid)
      console.log("currentElementId", currentElementId)
      console.log("this.creditAvailable", this.creditAvailable)



      if (this.planid == "11") {

        // En caso de que el credito sea mayor a 50
        if (this.creditAvailable >= 50 && currentElementId == "#hintnewEstimate") {
          console.log("paso 1")


          this.popupNewEstimateQuick = true

          dataSteps.splice(0, 1);

          setTimeout(() => {
            console.log("paso 4")
            this.activeStepper(dataSteps, component, false, true)
          }, 300);

        } else if (currentElementId == "#hintCreateNewProject" && this.creditAvailable >= 50) {
          this.popupCreateSalesProject = true

          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.activeStepper(dataSteps, component, false, true)
          }, 300);

        }
        else if (currentElementId == "#hintNameProject" && this.creditAvailable >= 50) {

          if (this.projectName != undefined && this.projectName != "" && this.projectName != null) {
            dataSteps.splice(0, 1);
          } else {
            this.toast.warning("You must write a Project Name")
          }

          console.log("paso 3 sndglkdfnlgkndlfkkgn")

          setTimeout(() => {
            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        } else if (currentElementId == "#hintSaveButtonProject" && this.creditAvailable >= 50) {
          this.popupCreateSalesProject = false
          this.createProject()
          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        } else if (currentElementId == "#hintSaveButtonEstimate" && this.creditAvailable >= 50) {
          console.log("paso 5kdnfkdnffgknd")

          console.log(this.creditAvailable)
          console.log(this.estimateCost)
          console.log(this.remainingBalance)

          this.showPopupPlane = true
          this.saveOrDuplicate = "Save"

          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        }

        // En caso de que el credito sea menor a 50
        if (currentElementId == "#hintnewEstimate" && 50 > this.creditAvailable) {
          this.popupInsufficientCredits = true
          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        }


      } else {

        if (currentElementId == "#hintnewEstimate") {
          console.log("paso 1")

          this.popupNewEstimateQuick = true



          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.introJS.exit();

            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        } else if (currentElementId == "#hintCreateNewProject") {

          this.popupCreateSalesProject = true

          dataSteps.splice(0, 1);

          setTimeout(() => {
            this.introJS.exit();

            this.activeStepper(dataSteps, component, false, true)
          }, 500);
        } else if (currentElementId == "#hintSaveButton") {
          this.createProject()
        }
      }


    }).onchange((targetElement) => {


    }).onhintclick(() => {
    }).oncomplete(() => {

      console.log("this.planid", this.planid)
      console.log("this.creditAvailable", this.creditAvailable)

      if (this.planid == "11" && 50 > this.creditAvailable) {
        if (dataSteps.length > 0) {
          if (dataSteps[0].element == "#hintGoToCredit") {
            this.navigateToMyAccount()
          }
        }

      } else if (this.planid == "11" && this.creditAvailable >= 50) {
        this.introJS.exit();
        localStorage.setItem("showSteppfirts", "Yes");
        this.SaveEstimatePay()
      } else {
        this.introJS.exit();
        localStorage.setItem("showSteppfirts", "Yes");
        this.createEstimate()
      }
    }).start();
  }

  nextStepFunction() {
    this.introJS.nextStep();
  }

  goBackToAssistant: boolean = false;


  nextStep() {

    console.log("componentSelected", this.componentSelected)
    if (this.componentSelected == "ENG-ENGPROJ-MODNEWEXCEL") {
      this.treeviewAreaSystem.openNewSystem()
      setTimeout(() => {
        this.treeviewAreaSystem.changeViewCard()
      }, 500);
    } else {
      setTimeout(() => {
        this.introJS.nextStep();
      }, 500);
    }

  }

  navigateToMyAccount() {
    this.introJS.exit();
    localStorage.setItem("showCreditsFirts", "Yes");
    this.router.navigate(['/my-account']);
    this.popupInsufficientCredits = false;
  }

  // a coprar creditos
  showModalMonto: boolean = false

  newEstimateFormat() {

    // this.showModalMonto = true
    // this.popupInsufficientCredits = true



    if (this.planid == "11") {
      this.MapInformationService.SaveInfoSites({
        method: "GetClientCubeShopCredit",
      }).subscribe(resp => {
        if (resp[0].credit) {

          if (resp[0].credit > 50) {

            this.currentBalance = resp[0].credit
            this.remainingBalance = this.currentBalance - this.estimateCost
            this.initformAndSelect()
            this.initForm()

            this.popupNewEstimateQuick = true

            if (this.IsAssistant) {
              setTimeout(() => {
                this.introJS.nextStep();
              }, 500);
            }
          } else {
            this.popupInsufficientCredits = true
            setTimeout(() => {
              this.introJS.nextStep();
            }, 500);
          }

        } else {
          this.popupInsufficientCredits = true
        }
      })

    } else {
      this.initformAndSelect()
      this.initForm()


      this.popupNewEstimateQuick = true

      if (this.IsAssistant) {
        setTimeout(() => {
          this.introJS.nextStep();
        }, 500);
      }

    }
  }

  closePopupSelectNew() {
    this.popupNewEstimateQuick = false;
    this.searchProject.instance.repaint()
    this.searchProject.instance.reset()

    if (this.searchProject != null) {
      this.searchProject.placeholder = "Search existing CUBE CRM projects, or click (+) to create a new one"
    }
  }




  validateFormCredit() {
    console.log("validateFormCredit", this.currentBalance, this.serviceCost)
    if (this.currentBalance < this.serviceCost) {
      this.popupInsufficientCredits = true
    } else {
      this.popupInsufficientCredits = false
      this.showPopupPlane = true
    }
  }

  closePopupPay() {
    console.log("closePopupPay")
    this.showPopupPlane = false
    const data = {
      showModalSuccess:true
    }
    this.returnClosePopupPay.emit(data)
  }

}
